import Vue from 'vue';
import 'reset-css';
import VueScreen from 'vue-screen';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import VueMultiselect from 'vue-multiselect';
import '@/assets/css/vue-multiselect.css';
import VueModal from 'vue-js-modal';
import VueLS from 'vue-ls';
import VueLazyLoad from 'vue-lazyload';
import LoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Notifications from 'vue-notification';

import '@/assets/styles/scss/general.scss';

import App from './App.vue';
import router from './router';
import store from './store';
import api from './services/api';
import { isTouchDevice } from '@/helpers';

import Checkbox from '@/components/form/checkbox';
import Switcher from '@/components/form/switcher';
import Input from '@/components/form/input';
import Autocomplete from '@/components/form/autocomplete';
import AutocompleteItem from '@/components/form/autocomplete-item';
import Chip from '@/components/tiny/chip';
import BoxFolding from '@/components/tiny/BoxFolding';
import FilterFolding from '@/components/tiny/FilterFolding';
import FormSlider from '@/components/form/slider';
import ModalToggler from '@/components/tiny/ModalToggler';
import Stars from '@/components/tiny/Stars';

Vue.component('chip', Chip);
Vue.component('form-checkbox', Checkbox);
Vue.component('form-switcher', Switcher);
Vue.component('form-input', Input);
Vue.component('form-autocomplete', Autocomplete);
Vue.component('autocomplete-item', AutocompleteItem);
Vue.component('box-folding', BoxFolding);
Vue.component('modal-toggler', ModalToggler);
Vue.component('stars', Stars);
Vue.component('filter-folding', FilterFolding);
Vue.component('form-slider', FormSlider);

Vue.use(VueScreen, {
  xss: 320,
  xs: 768,
  sm: 1024,
  tablet: 1280,
  laptop: 1366,
  md: 1600,
  lg: 1920,
});
Vue.component('VueSlider', VueSlider);
Vue.component('multiselect', VueMultiselect);
Vue.use(VueModal);
Vue.use(VueLS, {
  namespace: 'vuejs__',
  name: 'ls',
  storage: 'local',
});
Vue.use(VueLazyLoad);
Vue.use(LoadingOverlay);
Vue.use(Notifications);

Vue.config.productionTip = false;
Vue.prototype.$api = api;

document.body.classList.add(`${isTouchDevice() ? 'has-' : 'no-'}touchevents`);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
